import { render, staticRenderFns } from "./BorrowedVideoInfo.vue?vue&type=template&id=40197b4c&"
import script from "./BorrowedVideoInfo.vue?vue&type=script&lang=js&"
export * from "./BorrowedVideoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports